<script lang="ts">
  import WorkOrderAppointmentTag from "../../../../../../../../../../../_shared/_modules/work-order-appointment-tag"
  import { buildScheduleEventCommunicationTagPresentation } from "../../../../../../../../../../../../../_shared/_logic/communication-presentation"
  import { buildAppointmentTimeTagPresentation } from "../../../../../../../../../../../../../_shared/_logic/appointment-time-tags"
  import type { LetterAppointmentContext } from "../../../../../_shared/_logic/letter-table-tags"
  let {
    row,
  }: {
    row: LetterAppointmentContext & {
      appointment_start_at?: string | null
      appointment_end_at?: string | null
      appointment_status_code?: string | null
      appointment_label?: string | null
    }
  } = $props()
  const appointment = $derived(
    row.appointment ??
      (row.appointment_start_at
        ? {
            start_at: row.appointment_start_at,
            end_at: row.appointment_end_at,
            status: row.appointment_status_code,
            employee_name: null,
          }
        : null),
  )
  const time = $derived(buildAppointmentTimeTagPresentation(appointment))
  const communication = $derived(
    buildScheduleEventCommunicationTagPresentation({
      status: appointment?.status ?? "UNKNOWN",
      presentation: row.communication_presentation,
    }),
  )
  const status = $derived({
    ...communication.definition,
    label: appointment ? time.label : row.appointment_label || "Termin nicht mehr verfügbar",
  })
  const subLabel = $derived(
    [
      communication.label,
      row.appointment?.employee_name ? `Mitarbeiter: ${row.appointment.employee_name}` : null,
    ]
      .filter(Boolean)
      .join(" · "),
  )
</script>

<WorkOrderAppointmentTag
  {status}
  {subLabel}
  tooltipContent={communication.tooltip}
  historyLayout="stack"
/>
